var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.816,
    height: 32.689,
    viewBox: "0 0 32.816 32.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#455079;stroke-width:2.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.502 0.439)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.864,18.566a11.977,11.977,0,0,0,.1-1.472,9.053,9.053,0,0,0-.116-1.472l3.28-2.491a.765.765,0,0,0,.194-.962L29.214,6.943a.8.8,0,0,0-.951-.34L24.4,8.113a11.454,11.454,0,0,0-2.62-1.472l-.582-4A.769.769,0,0,0,20.422,2h-6.21a.749.749,0,0,0-.757.642l-.582,4a11.76,11.76,0,0,0-2.62,1.472L6.39,6.6a.778.778,0,0,0-.951.34L2.334,12.17a.718.718,0,0,0,.194.962l3.28,2.491a8.648,8.648,0,0,0-.019,2.943l-3.28,2.491a.765.765,0,0,0-.194.962L5.42,27.245a.8.8,0,0,0,.951.34l3.862-1.509a11.454,11.454,0,0,0,2.62,1.472l.582,4a.783.783,0,0,0,.776.642h6.21a.735.735,0,0,0,.757-.642l.582-4a11.76,11.76,0,0,0,2.62-1.472l3.862,1.509a.778.778,0,0,0,.951-.34L32.3,22.019a.718.718,0,0,0-.194-.962l-3.241-2.491ZM17.317,22.755a5.76,5.76,0,0,1-5.822-5.66,5.825,5.825,0,0,1,11.644,0A5.76,5.76,0,0,1,17.317,22.755Z",
    transform: "translate(-1.411 -1.189)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsDark);
export default __webpack_public_path__ + "static/media/settings-dark.b450ef207221c79df21549c4435bf452.svg";
export { ForwardRef as ReactComponent };